import { SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';

export const getDefaultLibrary = (options: Array<{ id: SubscriptionPackage.LibraryEnum }>, queryStringParam?: string | string[]) => {
    const foundOption = options.find((o) => o.id.toString() === queryStringParam);
    return (foundOption || options[0]).id;
};
